import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { PageContainer } from "@/components/PageContainer";
import { Button } from "@/components/ui/button";
import {
	CardHeader,
	CardTitle,
	CardDescription,
	CardContent,
	CardFooter,
} from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";
import { useCampaign } from "@/contexts/CampaignContext";

export function SubmittedPage() {
	const navigate = useNavigate();
	const { clearCampaign } = useCampaign();

	useEffect(() => {
		clearCampaign();
	}, []);

	const handleNewCampaign = () => {
		navigate("/create");
	};

	return (
		<PageContainer>
			<CardHeader className="text-center">
				<div className="flex flex-col items-center space-y-4">
					<div className="relative">
						<div className="absolute inset-0 animate-ping">
							<CheckCircle2 className="h-16 w-16 text-green-500/30" />
						</div>
						<CheckCircle2 className="h-16 w-16 text-green-500" />
					</div>
					<CardTitle className="text-2xl">
						Campaign Submitted Successfully!
					</CardTitle>
					<CardDescription className="text-lg">
						Thank you for submitting your campaign
					</CardDescription>
				</div>
			</CardHeader>
			<CardContent className="text-center space-y-6 mt-6">
				<p className="text-muted-foreground">
					Our team will review your campaign details and get back to you
					shortly. You will receive a confirmation email with further
					instructions.
				</p>
				<div className="p-4 border rounded-lg">
					<p className="font-medium">What happens next?</p>
					<ul className="mt-4 space-y-2 text-sm text-left list-disc list-inside">
						<li>Our team will review your campaign details</li>
						<li>You'll receive a confirmation email within 24 hours</li>
						<li>A campaign manager will contact you to discuss next steps</li>
						<li>Once approved, your campaign will be scheduled to run</li>
					</ul>
				</div>
			</CardContent>
			<CardFooter className="flex flex-col space-y-4">
				<Button
					className="w-full"
					onClick={() => navigate("/", { replace: true })}>
					View All Campaigns
				</Button>
				<Button
					variant="outline"
					className="w-full"
					onClick={handleNewCampaign}>
					Create Another Campaign
				</Button>
			</CardFooter>
		</PageContainer>
	);
}